<template>
 <div class="modal-accard-new">
    <el-dialog
    title="新建答题卡"
    :visible="isShow"
    width="920px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="closeDialog">
    <div class="sel-config" v-loading="loading">
      <div class="mt20">
        <span>学科：</span>
        <el-button
          v-for="(sub, index) in subjectList"
          :key="index"
          class="subject-button"
          size="mini"
          :type="sub.Id === subjectIndex ? 'primary' : 'text'"
          @click="changeSubject(sub.Id , index)">
          {{sub.Name}}
        </el-button>
      </div>
      <div class="mt20">
        <span>学段：</span>
        <el-button
          v-for="(gra, index) in gradeList"
          :key="index"
          class="subject-button"
          size="mini"
          :type="gra.Id === gradeIndex ? 'primary' : 'text'"
          @click="changeGrade(gra.Id , index)">
          {{gra.Name}}
        </el-button>
      </div>
    </div>
    <div class="ac-list">
      <el-row>
        <el-col :span="5" :offset="1">
          <el-card shadow="hover">
            <div class="card" @click="addAcCard">
              <i class="el-icon-plus"></i>
              <p>新建空白答题卡</p>
            </div>
          </el-card>
        </el-col>
        <el-col
          :span="5"
          v-for="(car,index) in layerList"
          :key="'car'+index"
          :offset="1"
          @mouseover.native="layerHover(index, 1)"
          @mouseout.native="layerHover(index, 0)"
        >
          <el-card shadow="hover">
            <div style="padding:5px;">
              <div class="img">
                <img src="@/assets/img/111.jpg" height="160" />
              </div>
              <p class="name">{{ subStrTemplateName(car.Name) }}</p>
             <!-- <p class="score">
                {{'题目数:' + car.Questions + ' 总分:'}}
                <span style="color:red">{{ car.TotalScore }}</span>
              </p>-->
              <div class="tag">
                <el-tag size="mini">{{ car.Period }}</el-tag>
                <el-tag size="mini">{{ car.km }}</el-tag>
              </div>
            </div>

            <div class="lay" v-show="mBIndex === index">
              <el-button type="primary" @click="editMB(car.AcCardGuid)">使用模板新建</el-button>
            </div>
            <div class="operation">
              <i class="el-icon-setting" style="color:#409EFF;font-size: 18px; cursor: pointer" @click="handleMBSetting(car)"></i>
              <i class="el-icon-edit-outline" style="margin:0 7px;color:#409EFF;font-size: 18px; cursor: pointer" @click="handleMBEditor(car)"></i>
              <div class="popover-wrap">
               <el-popover
                  placement="top"
                  width="280"
                  v-model="car.dialogVisibleMBDelete">
                  <p class="title">
                    <i class="el-icon-error"  style="color:red;font-size: 22px;"></i>
                    <span style="margin-left: 7px">提示</span>
                  </p>
                  <p class="content">是否确认删除模板:
                  <span style="color: #000">{{car.Name}}</span>
                    ？</p>
                  <div style="text-align: right; margin: 10px 0">
                    <el-button size="mini" type="text" @click="handleMBDeleteCancel(index)">取消</el-button>
                    <el-button type="primary" size="mini" @click="handleMBDeleteSubmit(index,car)">确定</el-button>
                  </div>
                   <!-- <el-button slot="reference">删除</el-button> -->
                    <i class="el-icon-delete" style="color:#409EFF;font-size: 18px; cursor: pointer"  slot="reference">
                    </i>
                </el-popover>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <p class="more">
      <el-button type="text" @click="moreMB">{{ !noMore ? '加载更多...' : '已经到底了'}}</el-button>
    </p>
  </el-dialog>
  <ModalCardEmpty :open="dialogVisibleEmpty" @onChange="handleEmptyDialogChange"/>
  <ModalTemplateSetting :params="modalTemplateSettingParams" :open="dialogVisibleMBSetting" @onChange="handleMBSettingDialogChange"/>
 </div>
</template>

<script>
  import AcCardApi from "@/services/acCard"
  import ModalCardEmpty from './home/modal-card-empty'
  import ModalTemplateSetting from './home/modal-template-setting'
  import { mapState, mapMutations } from "vuex";
  export default {
    name: "AcDialog",
    components: {
      ModalCardEmpty,
      ModalTemplateSetting
    },
    props: {
      value: {
        type: Boolean,
        required: true,
        default: false
      }
    },
    computed: {
    ...mapState("card", {
      kMAndPeriod: (state) => state.kMAndPeriod, //学科和学段的字典
     }),
    },
    watch: {
      value: {
        handler(value) {
          if (value) {
            this.pageIndex = 1
            this.pageSize = 3
            this.layerList = []
            this.$nextTick(() => {
              this.getKMAndPeriod()
              this.isShow = true
            })
          }

        }
      }
    },
    data() {
      return {
        isShow: false,
        subjectIndex: 0, //当前先中的学科
        subjectList: [], //所有学学科列表
        gradeIndex: 0, //当前选中的年级
        gradeList: [], //所有年级列表,
        pageIndex: 1,
        pageSize: 3,
        total: 0,
        noMore: false,// 是否还有剩余模板
        mBIndex: -1,
        layerList: [],
        loading: false,
        debounceTimer: undefined,
        dialogVisibleEmpty: false,
        dialogVisibleMBSetting: false,
        dialogVisibleMBDelete: true,
        modalTemplateSettingParams: {},
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      // 获取学科和 学段
      getKMAndPeriod() {
        AcCardApi.GetKMAndPeriod({}).then(res => {
          if(res.status === 200) {
            this.subjectList = res.data && res.data.KM || []
            this.subjectList.unshift({Id: 9999, Name: '全部'})
            this.subjectIndex = 9999
            this.gradeList = res.data && res.data.Period || []
            this.gradeList.unshift({Id: 9999, Name: '全部'})
            this.gradeIndex = 9999;
            this.getTemplateCardList()
          }
        })
      },
      // 获取模板列表
      getTemplateCardList(refresh) {
        this.loading = true
        const params = {
          KmCode: this.subjectIndex === 9999 ? '' : this.subjectIndex,
          Period: this.gradeIndex === 9999 ? '' : this.gradeIndex,
          pageSize: refresh ? 3 : this.pageSize,
          pageIndex: refresh ? 1 : this.pageIndex
        }
        AcCardApi.GetTemplateCardList(params).then(res => {
          if (res.status === 200) {
            if(refresh) {
              this.layerList = (res.data && res.data.list || []);
              this.noMore = Number(res.data.count) <= this.layerList.length;
              this.pageIndex = 1;
              this.pageSize = 3;
            } else {
              this.layerList = this.layerList.concat(res.data && res.data.list || []);
              this.noMore = Number(res.data.count) <= this.layerList.length;
            }
            this.loading = false
          }
        }).finally(() => {
          this.loading = false
        })
      },
      // 新建空白模板
      addAcCard() {
        // clearTimeout(this.debounceTimer);
        // this.debounceTimer = setTimeout(() => {
        //   // 防抖 这里避免对数据库秒级插入多条数据
        //   AcCardApi.AddAcCard({addType: 1,acCardGuid: '' }).then(res => {
        //     if (res.status === 200) {
        //       this.$message({
        //         type: "success",
        //         message: "成功新建空白模板!",
        //       });
        //       this.$router.push({ path:'/card',query: { guid: res.data.AcCardModel && res.data.AcCardModel.acCardGuid || '' }})
        //   }
        //   })
        // },800)
        this.addEmptyAcCard();
      },
      addEmptyAcCard() {
        this.dialogVisibleEmpty = true;
        this.closeDialog();
      },
      handleEmptyDialogChange(data) {
        this.dialogVisibleEmpty = false;
        if(data == 'cancel') {
          this.isShow = true
        }
      },
      handleMBSettingDialogChange(data) {
        this.dialogVisibleMBSetting = false;
        if(data == 'cancel') {
          this.isShow = true
        }
      },
      // 是否展示模板遮罩层
      layerHover(i, type) {
       this.mBIndex =  type ? i : 'no'
      },
       // 切换科目
      changeSubject(id) {
        this.pageIndex = 1
        this.pageSize =3
        this.layerList = []
        this.subjectIndex = id
        this.getTemplateCardList()
      },
      // 切换学段
      changeGrade(id) {
        this.pageIndex = 1
        this.pageSize = 3
        this.layerList = []
        this.gradeIndex = id
        this.getTemplateCardList()
      },
      // 使用模板
      editMB(guid) {
        AcCardApi.TemplateToCard({acCardGuid: guid}).then(res => {
          if(res.status === 200) {
            this.$message({
              type: "success",
              message: "成功使用模板!",
            });
            this.$router.push({ path:'/card',query: { guid: res.data.acCardGuid || '' }})
          }
        })
      },
      // 加载更多模板
      moreMB() {
        // 加4个
        if(!this.noMore) {
          this.pageIndex += 1
          this.pageSize = 4
          this.getTemplateCardList()
        }
      },
      closeDialog(){
        this.isShow = false
        this.$emit('input', false)
      },
      handleMBSetting(data) {
        this.isShow = false
        this.dialogVisibleMBSetting = true;
        this.modalTemplateSettingParams = data;
      },
      handleMBEditor(data) {
        this.$router.push({ path:'/card',query: { guid: data.AcCardGuid || '' }})
      },
      handleMBDelete(index) {
       this.layerList[index] && (this.layerList[index].dialogVisibleMBDelete = true);
      },
      handleMBDeleteCancel(index) {
       this.layerList[index] && (this.layerList[index].dialogVisibleMBDelete = false);
      },
      handleMBDeleteSubmit(index,data) {
       this.delCardTemplate(data);
       this.layerList[index] && (this.layerList[index].dialogVisibleMBDelete = false);
      },
      async delCardTemplate(data) {
        const result = await AcCardApi.DelCardTemplate({
          acCardGuid: data.AcCardGuid
        });
        if(result.status == 200) {
          this.$message({
            message: '操作成功~',
            type: 'success'
          });
          this.getTemplateCardList(true);
        } else {
          this.$message({
            message: result.message,
            type: 'error'
          });
        }
      },
      subStrTemplateName(name) {
        return  name.length >= 20 ? `${name.substr(0, 20)}...` : name
      }
    }
  }
</script>

<style lang="scss" >
  .mt20{
    margin-bottom: 20px;
    .subject-button{
      display: inline-block;
      padding: 10px 20px;
    }
  }
  .new-card{
    height: 200px;

  }
  .el-card {
    width: 180px;
    margin-top: 20px;
    position: relative;
    height: 190px;
    .el-card__body {
      padding: 0px;
      height: 100%;
    }
    .img {
      height: 90px;
      text-align: center;
      overflow: hidden;
      img {
        width: auto;
        height: 100%;
        margin: 0 auto;
      }
    }
    .name {
      padding: 8px 0;
      height: 36px;
      text-align: center;
    }
    .tag {
      padding-top: 8px;
      .el-tag {
        margin-right: 5px;
      }
    }
    .score {
      color: #999;
    }
    .card {
      background: #f6f6f6;
      text-align: center;
      height: 100%;
      cursor: pointer;
      color: #bbbbbb;
      i {
        margin-top: 50px;
        margin-bottom: 10px;
        font-size: 50px;
      }
    }
  }
  .lay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.2);
    text-align: center;
    line-height: 190px;
  }
  .operation{
    position: absolute;
    top: 6px;
    right: 8px;
    display: flex;
   }
 
  .more{
    height: 40px;
    margin-top: 20px;
    text-align: center;
    color: #00a2d4;

  }
  .el-popover{
    .title{
      display: flex;
      align-items: center;
    }
    .content{
      margin-left: 28px;
      margin-top: 6px;
      color: #999;
    }
  }
</style>